import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ConfigurableTableComponent} from './configurable-table.component';
import {MatTableModule} from "@angular/material/table";
import {TdTextModule} from "../td-text/td-text.module";
import {ThTextModule} from "../th-text/th-text.module";
import {ConfigurableTdContentModule} from "../configurable-td-content/configurable-td-content.module";
import {BtnModule} from "../../../ui_button/btn.module";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {ConfigurableTablePipeModule} from "../../../pipes/configurable-table/configurable-table-pipe.module";
import {MatListModule} from "@angular/material/list";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {FormsModule} from "@angular/forms";
import {PermissionModule} from "../../../permission/permission.module";


@NgModule({
    declarations: [
        ConfigurableTableComponent
    ],
    exports: [
        ConfigurableTableComponent
    ],
    imports: [
        CommonModule,
        MatTableModule,
        TdTextModule,
        ThTextModule,
        ConfigurableTdContentModule,
        BtnModule,
        FontAwesomeModule,
        ConfigurableTablePipeModule,
        MatListModule,
        MatCheckboxModule,
        MatSlideToggleModule,
        FormsModule,
        PermissionModule,
    ]
})
export class ConfigurableTableModule {
}
